$(document).ready(function(){

    if($(".template-product").length == 0){
      return false;
    }
  
    let currItemsCount = null
    let itemsLenght = null
    let qty = 0;

    let ids = [];
    let arraySinRepetidos = (array) => {
      array.filter(function(value, index, self) {
        return self.indexOf(value) === index;
      });
    }

    let variantsHelper = document.getElementById('variants_helper');
    let variantContent = JSON.parse(variantsHelper.textContent);
    let variantContainer = document.getElementById('cart-notification-products');
    let global_featured = document.getElementById('variants_featured');
    let global_content = JSON.parse(global_featured.textContent);
    const getVariantInfo = (id) =>{
      for (var i = 0; i < variantContent.length; i++) {
        if (variantContent[i].id == id) {
          variant = variantContent[i];
          break;
        }
      }
      if (variant) {
        // Obtener el nombre y la imagen de la variante
        let productName = global_content.product_name;
        let variantName = variant.title; // Nombre de la variante
        let variantImage = null; // Imagen de la variante
        let variantDiv = document.createElement('div');
        variantDiv.setAttribute('class', 'cart-notification__product');

        if (variant.featured_image && variant.featured_image.src) {
          variantImage  = variant.featured_image.src;
          let variantHTML = `<div class="cart-notification__product-image">
          <img
            src="${variantImage}"
            loading="lazy">
          </div>
          <div>
          <h3 class="cart-notification__product-name ttl-14 uppercase">${productName}</h3>
          <div class="cart-notification__product-variants">
            <div class="product-option txt-13-600 uppercase">
              <p>${variantName}</p>
            </div>
          </div>
          </div></div>`;
        variantDiv.innerHTML = variantHTML;
        } else {
          // featured_image.src es nulo
          console.log('featured_image.src es nulo');
          let variantHTML = `<div class="cart-notification__product-image">
          <img
            src="${global_content.featured_image}"
            loading="lazy">
          </div>
          <div>
          <h3 class="cart-notification__product-name ttl-14 uppercase">${productName}</h3>
          <div class="cart-notification__product-variants">
            <div class="product-option txt-13-600 uppercase">
              <p>${variantName}</p>
            </div>
          </div>
          </div></div>`;
          variantDiv.innerHTML = variantHTML;
        }
        variantContainer.appendChild(variantDiv);
      } else {
        console.log('No se encontró la variante con el ID especificado.');
      }
    }

  
    jQuery.getJSON('/cart.js', function(cart) {
      currItemsCount = cart.item_count
      $.each(cart.items, function(i, item) {
        $("octo-wholesale-qty").val(0)
        itemsLenght = cart.items                
        $(`#qty_${item.variant_id}`).val(item.quantity).trigger("change")

        $(`#qty_${item.variant_id}`).data('value', item.quantity);
        $(`#qty_${item.variant_id}`).attr('data-value', item.quantity);
  
      }); 
    });
  
    $( ".wrapper-table-octo tbody .title .getTitile" ).hover(
      function() {      
        let currIdHovered = $(this).text().trim()
        console.log(currIdHovered)
        $(`.single-option-selector option`).attr("selected", false)
        $(`.single-option-selector`).val(currIdHovered).trigger("change")       
      }
    );  
  
    //add from wholesale
    let getOctoCart = async function(){
      let data = await jQuery.getJSON('/cart.js');
      return data;
    }
  
    var formData = {             
      items: [] 
    };
  
  
    var current_items = {};
    var formDataUpdates = {             
  
    };
    
    document.getElementById("octo-wholesale-btn").onclick=async (e)=> {
      e.preventDefault();
      variantContainer.innerHTML = '';
      formData = {  items: [] };
      current_items = {};
      formDataUpdates = {};
      ids=[];

      arraySinRepetidos(ids);
  
      $(".octo-wholesale-btn").attr("disabled", true)
      $(".octo-wholesale-btn").addClass("disabled")
      $(".octo-wholesale-btn").html('<span class="txt-btn"> Agregando...</span>')
      
      let current_cart = await  getOctoCart();
      Object.keys(current_cart.items).forEach(function(item_index){
        current_variant=current_cart.items[item_index].variant_id;
        current_items[current_variant] = current_variant;
      });
  
      $(".octo-wholesale-qty").each(function() {
        let variant_id = $(this).attr("data-variant_id");           
        qty = $(this).val();
  
        if(current_items.hasOwnProperty(variant_id)){
          console.log("SI ESTAN EN CARRITO")
          formDataUpdates[variant_id] =qty;
          if(qty > 0){
            ids.push(variant_id);
          }else{
            arraySinRepetidos(ids);
          }
        }else{
          console.log("NO ESTAN EN CARRITO**")
          if(qty > 0){
            formData.items.push({
              'id': variant_id,
              'quantity': qty
            })
            ids.push(variant_id)
          }
        }
      }); 
  
      if(formData.items.length > 0){
        await octoAddTocart();
      }
  
  
      let update_counter = 0;
      Object.keys(formDataUpdates).forEach(function(update_index){
        update_counter++;      
      });
  
      if(update_counter > 0){
        await octoUpdateTocart();
      }
  
      if(update_counter < 1 && formData.items.length < 1){
        $("#setError").removeClass("hide")
        $(".octo-ajaxified-cart-feedback").addClass("hide")
        setTimeout(function(){
          $("#setError").addClass("hide")
          $("#octo-wholesale-btn").attr("disabled", false).removeClass("disabled").html('<span class="txt-btn">Agregar a la bolsa</span>')
  
        },2000)
      }
  
      //Notificación de Carrito de Compras (Mayoreo)
      current_cart = await  getOctoCart();
      $('#cart-notification-total-mayoreo').removeClass("hide");
      $('#cart-notification-products').removeClass('hide');
      for (var i = 0; i < ids.length; i++) {
        getVariantInfo(ids[i]);
      }
      $(".octo-ajaxified-cart-feedback").removeClass("hide");
      $(".cart-count").html(current_cart.item_count).removeClass("hidden-count")
  
    };
  
    let octoAddTocart = async function(){
      console.log("VAmos a agregar");
      // Llama a la función para actualizar/agregar la cookie del carrito después de renderizar el contenido
      setCartTimestamp();
      variantContainer.innerHTML = '';
      await fetch(`/cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        $(".octo-wholesale-btn").attr("disabled",false).removeClass("disabled");
        $(".octo-wholesale-btn").html('<span class="txt-btn">Agregar a la bolsa</span>');
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
  
    let octoUpdateTocart = async function(){
      //console.log("VAmos a actualizar")
      variantContainer.innerHTML = '';
      await fetch(`/cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates: formDataUpdates
        })
      })
      .then(response => {
        $(".octo-wholesale-btn").attr("disabled",false).removeClass("disabled");
        $(".octo-wholesale-btn").html('<span class="txt-btn">Agregar a la bolsa</span>')
        
        let currCart = $(".cart-count").html()
        currCart = parseInt(currCart)
  
        let updateNumber  = currCart + qty;
        $(".cart-count").html(updateNumber).removeClass("hidden-count");

        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });  
  
    }
  
    //Get prices from hulk app
  
    var product_price = window.hulkapps.product.price/100;
    var hulkFormData = {pid: window.hulkapps.product_id, 
                        store_id: window.hulkapps.store_id,
                        product_variants: window.hulkapps.product_variant[0],
                        product_collections: window.hulkapps.product_collections 
                       };
    //console.log(hulkFormData)
    var offer_levels;
    fetch('https://volumediscount.hulkapps.com/api/v2/shop/get_offer_table', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(hulkFormData)
    })
    .then(response => {
      return response.json();
    })
    .then(response => {
      offer_levels = JSON.parse(response.eligible_offer.offer_levels)
      //console.log(offer_levels)
    })
    .catch((error) => {
      console.error('Error:', error);
    });

    

    function getTotalFromHulk(qty, currId) {
      let product_prices = {};  // Almacena los precios de las variantes
      // Llena product_prices con información de precios de variantes
      variantContent.forEach(function(variant) {
        product_prices[variant.id.toString()] = variant.price / 100;  // Convierte el ID a cadena
      });
      let variant_id = currId;
  
      let product_price_hulk = product_prices[variant_id] || product_price;
    
      if (qty > 0) {
        Object.keys(offer_levels).forEach(function(k) {
          if (qty >= offer_levels[k][0]) {
            product_price_hulk = offer_levels[k][1];
          }
        });
      }

      total = qty * product_price_hulk
      newPrice = product_price_hulk
  
  
      $("#octo_total_qty").text(qty);
      $("#octo_precio").text(product_price_hulk);    
      let output= parseFloat(total).toLocaleString();         
      $("#octo_total_money").text(output + " MXN");

      $('#total_price_mayoreo').text(output + " MXN");  

      $(".octo-wholesale-btn").removeClass("disabled")
    }
  
    function delay(callback, ms) {
      var timer = 0;
      return function() {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          callback.apply(context, args);
        }, ms || 0);
      };
    }
  
    $('.octo-wholesale-qty').keyup(delay(function (e) {

      $('#cart_notification_mayoreo').addClass('hide');
      variantContainer.innerHTML = '';
      let currInventory = $(this).attr("data-stock")
      currInventory = parseInt(currInventory)    
      let curQty = $(this).val()
      curQty = parseInt(curQty)    
      let saveThis = $(this)
      let currId = $(this).data('variant_id');
  
      if(curQty > currInventory){
        saveThis.val(0)
        $(saveThis).data('value', 0);
        $(saveThis).attr('data-value', 0);
        $(this).siblings(".full-inventory").html("Exediste el limite disponible").removeClass("hide")
        $(".octo-wholesale-btn").attr("disabled", true).addClass("disabled")
        setTimeout(function(){
          $(".full-inventory").html("").addClass("hide")
          $(".octo-wholesale-btn").attr("disabled", false).removeClass("disabled")
        },2000)       
      }else{
        $(saveThis).data('value', curQty);
        $(saveThis).attr('data-value', curQty);
      }
  
      if($(this).val() == "" || $(this).val() < 0){
        return false
        $(this).val(0)
      }
      qty = 0;
      $(".octo-wholesale-qty").each(function() {   
        qty = qty + parseInt($(this).val());
      });
  
      getTotalFromHulk(qty, currId)
    }, 500));
  
    $('.octo-wholesale-qty').change(delay(function (e) {
      $('#cart_notification_mayoreo').addClass('hide');
      variantContainer.innerHTML = '';
      let currInventory = $(this).attr("data-stock")
      currInventory = parseInt(currInventory)    
      let curQty = $(this).val()
      curQty = parseInt(curQty)    
      let saveThis = $(this);
      let currId = $(this).data('variant_id');
      if(curQty > currInventory){
        saveThis.val(0);
        $(saveThis).data('value', 0);
        $(saveThis).attr('data-value', 0);
        $(this).siblings(".full-inventory").html("Exediste el limite disponible").removeClass("hide")
        $(".octo-wholesale-btn").attr("disabled", true).addClass("disabled");
        setTimeout(function(){
          $(".full-inventory").html("").addClass("hide")
          $(".octo-wholesale-btn").attr("disabled", false).removeClass("disabled")
        },2000)       
      }else{
        $(saveThis).data('value', curQty);
        $(saveThis).attr('data-value', curQty);
      }
  
  
      if($(this).val() == "" || $(this).val() < 0){
        return false
      }
      qty = 0;
      $(".octo-wholesale-qty").each(function() {   
        qty = qty+parseInt($(this).val());      
      });
  
      getTotalFromHulk(qty, currId)
    }, 500));
  
    $('#close_notification_mayoreo').on('click', function(){
      $('#cart_notification_mayoreo').addClass('hide');
      variantContainer.innerHTML = '';
    })
    
  })